{
    "mcpPermissions": {
        "menu": "MCP-verktøytillatelser",
        "title": "MCP-verktøytillatelser",
        "info": {
            "interim": "En tom tillatelsesliste gir for øyeblikket tilgang til ALLE verktøy (midlertidig policy). For å faktisk begrense en bruker må minst ett verktøy være avkrysset."
        },
        "column": {
            "permissions": "MCP-tillatelser"
        },
        "badge": {
            "unrestricted": "Ubegrenset (alle verktøy)"
        },
        "filter": {
            "tools": "Filtrer verktøy…"
        },
        "action": {
            "selectAll": "Kryss av alle",
            "clearAll": "Fjern alle"
        },
        "save": "Lagre",
        "loadError": "Kunne ikke laste verktøytillatelser",
        "emptyWarn": {
            "header": "Tom tillatelsesliste gir ALLE verktøy",
            "message": "Disse brukerne ville fått en tom tillatelsesliste, som for øyeblikket gir tilgang til ALLE verktøy (midlertidig policy): {users}. For å faktisk begrense dem må minst ett verktøy være avkrysset. Lagre likevel?",
            "accept": "Lagre likevel"
        },
        "dialog": {
            "title": "MCP-tillatelser — {name}",
            "saved": "MCP-tillatelser oppdatert",
            "saveError": "Kunne ikke oppdatere MCP-tillatelser"
        }
    }
}
